import React from "react";

const AboutCompany = () => {
  return (
    <React.Fragment>
      {/* App-Solution-Section-Start */}

      <section
        className="float-left w-100 position-relative perfect-domain-name-con padding-top padding-bottom main-box"
        id="features"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6">
              <div className="appie-features-9-area-thumb">
                <img
                  src="/images/recharge-banner.png"
                  alt="about-us"
                  width={550}
                />
              </div>
            </div>
            <div className="col-xl-6 text-center text-xl-left pt-5 pt-xl-0">
              <div className="appie-features-9-area-heading">
                <h2>About Pay Fing</h2>
              </div>
              <p className="text-justify">
                Pay Fing, a brand of Fing Technologies LLP, is a trusted
                platform dedicated to empowering retailers with seamless digital
                services. We specialize in Mobile Recharge, DTH Recharge, Google
                Play Recharge, Utility Bill Payments, and PAN Card Services,
                ensuring a hassle-free experience with fast transactions and
                high commissions.
              </p>
              <p className="text-justify pt-2 pb-4">
                Our mission is to simplify digital payments and financial
                services, enabling retailers to grow their businesses with
                secure, reliable, and user-friendly solutions. With 24/7 support
                and a commitment to innovation, Pay Fing is your go-to partner
                for all recharge and utility service needs.
              </p>
              <a href="/about_us">
                <div class="primary-button d-inline-block">
                  <button type="submit" id="submit">
                    Read More
                  </button>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* App-Solution-Section-end */}
    </React.Fragment>
  );
};

export default AboutCompany;
